import React, { forwardRef } from 'react';
import styles from './FormCheckbox.module.css';

const FormCheckbox = forwardRef(({
    label,
    name,
    checked,
    onChange,
    error,
    required = false,
    disabled = false,
    className = '',
    style = {},
    ...props
}, ref) => {
    const checkboxId = `checkbox-${name}`;

    return (
        <div className={`${styles.container} ${className}`} style={style}>
            <label className={`${styles.checkboxWrapper} ${disabled ? styles.disabled : ''}`} htmlFor={checkboxId}>
                <input
                    ref={ref}
                    id={checkboxId}
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    required={required}
                    className={styles.checkboxInput}
                    {...props}
                />
                <span className={`${styles.checkmark} ${error ? styles.hasError : ''}`}></span>
                {label && <span className={styles.label}>{label}</span>}
            </label>

            {error && (
                <div className={styles.error} role="alert">
                    {error}
                </div>
            )}
        </div>
    );
});

FormCheckbox.displayName = 'FormCheckbox';

export { FormCheckbox };
export default FormCheckbox;
